import * as z from "zod";
import {
  inboundComingKeySchema,
  inboundWaitingAgeBucket,
} from "./get-inbound-dashboard-returns";

export const getInboundDashboard = {
  name: "getInboundDashboard" as const,
  input: z.object({ teamIds: z.array(z.string()).optional() }),
  output: z.object({
    brandOptions: z.array(z.object({ id: z.string(), name: z.string() })),
    /** Today in the warehouse timezone, `YYYY-MM-DD`. */
    today: z.iso.date(),
    inTransitCount: z.number(),
    deliveredTodayCount: z.number(),
    waitingCount: z.number(),
    oldestUnsortedHours: z.number().nullable(),
    sortedTodayCount: z.number(),
    sortedPerHour: z.number(),
    sortedProjected: z.number(),
    /** Counts returns; a multi-box return counts in every bucket one of its boxes is due in. */
    coming: z.array(
      z.object({ key: inboundComingKeySchema, count: z.number() }),
    ),
    waitingAges: z.array(
      z.object({ bucket: z.enum(inboundWaitingAgeBucket), count: z.number() }),
    ),
    missingCount: z.number(),
    generatedAt: z.string(),
  }),
};

export type GetInboundDashboardOutput = z.infer<
  (typeof getInboundDashboard)["output"]
>;
